<template>
  <div class="justify-content-center row">
    <b-card header-tag="header" class="col-md-6">
      <template v-slot:header>
        {{ $t("Logotipo ou Brasão da Unidade/Secretaria/Prefeitura") }}
      </template>
      <div class="form-group mb-0">
        <b-img
          :alt="$t('Unidade avatar')"
          :src="item.avatar ? item.avatar : '/img/avatar_default.png'"
          center
          class="mb-3 img-settings"
        />
        <b-form-file
          :browse-text="$t('Browse')"
          :placeholder="$t('Choose a file') + '...'"
          @change="changeAvatar"
          accept=".jpg, .png"
          class="pointer"
          id="unidade_avatar"
          no-drop
          ref="unidade_avatar"
        />
        <small>{{
          $t(
            "A imagem deve ser jpeg/png com no máximo 512x512px de largura e 1MB de tamanho"
          )
        }}</small>
      </div>
    </b-card>
  </div>
</template>
<script>
export default {
  props: ["item"],
  name: "AddLogotipo",
  methods: {
    // Change user avatar
    changeAvatar(e) {
      // Set formData
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("id", this.$route.params.id);
      // Update image
      axios
        .post("api/dashboard/unidades/avatar", formData, {
          header: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.item.avatar = URL.createObjectURL(e.target.files[0]);
          this.$refs["unidade_avatar"].reset();

          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        });
    },
  },
};
</script>
